module.exports = __webpack_public_path__ + "7e1c0f0f611b7c2c0e2d9c2f47f3c131.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/venn_for_sellers.png
// module id = 223
// module chunks = 0